import { useSelector } from 'react-redux';
import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import AccountMenu from './AccountMenu';

export default function Header() {

  const token = useSelector(state => state.auth.token);

    return (
      <AppBar position="static" sx={{ bgcolor: "#FFFFFF", pl: 1, pr: 1, height: "65px", padding: 0 }}>
        <Toolbar disableGutters sx={{ display: "flex", width: "100%", height: "100%" }}>
          <Box sx={{ display: "flex", alignItems: "center", width: "30%", height: "100%", background: "red" }}>
            {/* <img src={'/abg.png'} title="ABG" alt="ABG" className="logos-color"  /> */}
            <Box sx={{background:"red"}} >
              <Typography
                variant="h4"
                sx={{ color:"white", paddingLeft:"40px" }}
              >
                Avis Budget Group
              </Typography>
            </Box>
            {/* <Divider
              orientation="vertical"
              variant="middle" flexItem
              sx={{ bgColor: "secondary.light", ml: 2, height: "80%" }}
            /> */}
          </Box>
         
          <Box sx={{ display: "flex", justifyContent:"center", width: "35%" }}>
            <Typography
              variant="h6"
              // component="div"
              sx={{ flexGrow: 0, color: "text.primary" }}
            >
              PARTNER PORTAL
            </Typography>
          </Box>   

          {token && <Box sx={{ width: "33%", display: "flex", justifyContent: "flex-end", paddingRight: "2%" }}> <AccountMenu /> </Box> }
        </Toolbar>
      </AppBar>
    );
  }